const aiAssistantSettingControls = {
    TOGGLE: 'TOGGLE',
    SEGMENTED: 'SEGMENTED',
};

export default aiAssistantSettingControls;
